<template>
	<div class="thirdLogin">
		<a-spin :spinning="spinning" tip="加载中" :delay="100">
		</a-spin>
	</div>
</template>
  
<script>
import { encryption } from '../utils/crypto';
import closeMes from '../utils/clearTime.js';
export default {
	data() {
		return {
			account: '',
			password: '',
			spinning: true,
			path: null,
			params: null
		};
	},
	created() {
		localStorage.setItem('index1', 1);
		localStorage.setItem('index2', 1);
	},
	mounted() {
		// 1.获取 query 参数
		let params = this.$route.query;
		this.params = JSON.parse(JSON.stringify(params));

		// 如果路由带 isFlag，则同步到 Vuex 中
		if (params && params.isFlag) {
			localStorage.setItem('SystemName', 'XSGLXT');
		} else {
			localStorage.setItem('SystemName', null);
		}

		// 2.获取跳转页面的链接
		if (params && params.path) {
			let path = params.path;
			this.path = path;
			
			// 3.如果是系统则先出实话Audio
			this.initAudio();
			// 4.执行登录操作
			if (params.appid && params.appSecret) {
				let hasLogin = document.cookie.indexOf("userInfo");
				if(params.isFlag) return this.thirdLogin(params);
				if (hasLogin >= 0) {
					this.pushPage(params);
				} else {
					this.thirdLogin(params);
				}
			} else {
				this.$message.error('登录信息参数缺失，请检查参数')
				this.spinning = false;
			}
		} else {
			this.$message.error('路径缺失，请检查参数')
			this.spinning = false;
		}
	},
	methods: {
		// 初始化 Audio
		initAudio() {
			if (this.path == 'system') { // 跳转系统
				let audio = document.getElementById('music');
				if (!audio) {
					let video = document.createElement('audio');
					video.src = './assets/video/sound_Alarm.mp3';
					video.id = 'music';
					video.style.cssText = 'display:none';
					video.controls = 'controls';
					video.loop = 'loop';
					let body = document.body;
					body.appendChild(video);
				} else {
					let audio = document.getElementById('music');
					audio.volume = 0;
					// audio.pause();
				}
			}
		},
		pushPage(params) {
			document.cookie = "isHiddenTopNav=0"
			if (this.path == 'system') { // 跳转系统
				if (this.$getCookie('userInfo').user.roleId == 1) {
					this.$router.replace({
						path: '/admin',
					});
				} else if (this.$getCookie('userInfo').user.roleId == 2) {
					if (params.subPath && (params.subPath == 'home' || params.subPath == 'realTimeMonitor' || params.subPath == 'oldHealthy' || params.subPath == 'record')) {
						document.cookie = "isHiddenTopNav=1"
						this.$router.replace({
							path: '/dean' + '/' + params.subPath,
							//path:"dean/realTimeMonitor",
						});
					} else {
						this.$router.replace({
							path: '/dean',
							//path:"dean/realTimeMonitor",
						});
					}
				} else if (this.$getCookie('userInfo').user.roleId == 3) {
					this.$router.replace({
						path: '/protect',
					});
				} else {
					this.$message.success('登录成功！', 1.5);
					this.$router.replace({
						path: '/superAdmin',
					});
				}
				let audio = document.getElementById('music');
				audio.play();
				audio.volume = 0;
			} else if (this.path == 'report') { // 跳转报告
				if (!(this.params.sn && this.params.date)) {
					this.$message.error('报告参数缺失，请检查');
					this.spinning = false;
					return
				}
				let needPath = '/report?';
				if (this.params.sn) {
					needPath += ('sn=' + this.params.sn);
				}
				if (this.params.date) {
					needPath += ('&date=' + this.params.date);
				}
				this.$router.replace({
					path: needPath,
				});
			} else if (this.path == 'portrait') { // 跳转画像
				if (!this.params.sn) {
					this.$message.error('报告参数缺失，请检查');
					this.spinning = false;
					return
				}
				let needPath = '/portrait?';
				if (this.params.sn) {
					needPath += ('sn=' + this.params.sn);
				}
				this.$router.replace({
					path: needPath,
				});
			} else if (this.path == 'redZone') {
				if (!this.params.sn) {
					this.$message.error('报告参数缺失，请检查');
					this.spinning = false;
					return
				}
				let needPath = '/redZone?';
				if (this.params.sn) {
					needPath += ('sn=' + this.params.sn);
				}
				if(this.params.bedId) {
					needPath += ('&bedId=' + this.params.bedId);
				}
				this.$router.replace({
					path: needPath,
				});
			}
		},
		// 三方登录
		thirdLogin(params) {
			document.cookie = "isHiddenTopNav=0"
			this.account = this.params.appid;
			this.password = this.filterStr(this.params.appSecret);
			// let param = `?password=${encodeURIComponent(
			// 	encryption(this.password)
			// )}&username=${this.account}`;
			let param = `?password=${this.password}&username=${this.account}`;
			this.$loginpost(
				'/api/login' + param,
				{},
				(res) => {
					// console.log(res);
					if (res.code == 0) {
						var d = new Date();
						let c = 86400 / res.expires_in;
						d.setDate(d.getDate() + c);
						document.cookie =
							'userInfo' +
							'=' +
							encodeURIComponent(JSON.stringify(res.data)) +
							';expires=' +
							d.toGMTString() +
							'; path=/';
						this.$store.commit('stateFun', {
							name: 'user_info',
							val: res.data.user,
						});
						localStorage.setItem('audioval', 1);
						if (this.path == 'system') { // 跳转系统
							if (res.data.user.roleId == 1) {
								this.$router.replace({
									path: '/admin',
								});
							} else if (res.data.user.roleId == 2) {
								if (params.subPath && (params.subPath == 'home' || params.subPath == 'realTimeMonitor' || params.subPath == 'oldHealthy' || params.subPath == 'record')) {
									document.cookie = "isHiddenTopNav=1"
									this.$router.replace({
										path: '/dean' + '/' + params.subPath,
										//path:"dean/realTimeMonitor",
									});
								} else {
									this.$router.replace({
										path: '/dean',
										//path:"dean/realTimeMonitor",
									});
								}
							} else if (res.data.user.roleId == 3) {
								this.$router.replace({
									path: '/protect',
								});
							} else {
								this.$message.success('登录成功！', 1.5);
								this.$router.replace({
									path: '/superAdmin',
								});
							}
							let audio = document.getElementById('music');
							audio.play();
							audio.volume = 0;
						} else if (this.path == 'report') { // 跳转报告
							if (!(this.params.sn && this.params.date)) {
								this.$message.error('报告参数缺失，请检查');
								this.spinning = false;
								return
							}
							let needPath = '/report?';
							if (this.params.sn) {
								needPath += ('sn=' + this.params.sn);
							}
							if (this.params.date) {
								needPath += ('&date=' + this.params.date);
							}
							this.$router.replace({
								path: needPath,
							});
						} else if (this.path == 'portrait') { // 跳转画像
							if (!this.params.sn) {
								this.$message.error('报告参数缺失，请检查');
								this.spinning = false;
								return
							}
							let needPath = '/portrait?';
							if (this.params.sn) {
								needPath += ('sn=' + this.params.sn);
							}
							this.$router.replace({
								path: needPath,
							});
						} else if (this.path == 'redZone') {
							if (!this.params.sn) {
								this.$message.error('报告参数缺失，请检查');
								this.spinning = false;
								return
							}
							let needPath = '/redZone?';
							if (this.params.sn) {
								needPath += ('sn=' + this.params.sn);
							}
							if(this.params.bedId) {
								needPath += ('&bedId=' + this.params.bedId);
							}
							this.$router.replace({
								path: needPath,
							});
						}
						
					} else {
						this.$message.error(res.msg);
						closeMes(3000);
					}
					this.spinning = false;
				},
				(err) => {
					this.spinning = false;
					console.log(err);
					// this.$message.error('服务端发生异常');
				}
			);
		},
		filterStr (value){
			if(value) value=value.replace('#','%23')
			.replace('%','%25')
			.replace('&','%26')
			.replace('+','%2B')
			.replace('//','%2F')
			.replace('?','%3F')
			return value
		}
	},
};
</script>
<style lang="scss" scoped>
.thirdLogin {
	// height: 100vh;
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
  